import * as React from 'react';
import classNames from 'classnames';
import { Tabs as BaseTabs } from '@mc/react-core';

type Props = React.ComponentProps<typeof BaseTabs>;

const ClassName = `tabs tabs-light`;

export class LightTabs extends React.PureComponent<Props> {
  render() {
    const { className, ...other } = this.props;
    return <BaseTabs {...other} className={classNames(ClassName, className)} />;
  }
}
